import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, InputLabel, FormControl}  from '@material-ui/core';
import {Paper, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Select} from '@material-ui/core';

import MoreVert from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
//import { sortByLogin } from '../../../api/helpers';

class TemplatesListEditor_ extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            menuAnchor: null,
            typeFilter: 3
        }

        this.handleTypeFilterInput = this.handleTypeFilterInput.bind(this)
        this.handleTemplateSelect = this.handleTemplateSelect.bind(this)
    }

    handleTemplateSelect(templateID){
        this.props.onTemplateSelect(templateID)
    }

    getTemplateStyle(templateID){
        let selected = templateID === this.props.selectedTemplateID
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuItemClick(action, templateID){
        this.handleMenuClose();
        this.props.onAction({type: action, templateID: templateID})
    }   

    handleTypeFilterInput(event){
        const val =  Number(event.target.value)
        this.setState({typeFilter: val})
    }

    render(){

        console.log('render TemplatesListEditor')
        console.log(this.props)

        const {t} = this.props

        let templates = [];
        if(this.props.templates){
            //this.props.templates.sort(sortByLogin)

            if(this.state.typeFilter){
                templates = this.props.templates.filter(
                    (item) => item.Type === this.state.typeFilter
                )

            }else{
                templates = this.props.templates
            }
            

        }else{
            return '';
        }
        console.log('render this.props.templates')
        console.log(this.props.templates)



        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            },
            filter: {margin:'16px 0 8px 0'}
        };

        return(
            <>

                    <Box>
                        <Grid container>
                            <Grid item xs={6} align="left">

                                <FormControl style={{...styles.filter, width: '100%'}}>
                                    <InputLabel htmlFor="Priority">{t('Type')}</InputLabel>
                                    <Select
                                        value={this.state.typeFilter}
                                        disabled={true}
                                        style={{width: '100%'}}
                                        onChange={this.handleTypeFilterInput}
                                        name="typeFilter"
                                        label="Type"
                                        >
                                        <MenuItem key="13" value={3}>{t('Users')}</MenuItem>
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={6} align="right">
                                
                            </Grid>
                        </Grid>
                    </Box>

                <Paper style={styles.paper}>    

                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        title={t('AddTemplate')}
                                        onClick={()=>{this.handleMenuItemClick('FIELD_TEMPLATE_EDITOR_OPEN_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {templates.map((template) => 
                            <TableRow key={template.ID} 
                                    onClick={()=>{this.handleTemplateSelect(template.ID)}}
                                    onDoubleClick={(event)=>{
                                        this.handleMenuItemClick('FIELD_TEMPLATE_EDITOR_OPEN_EDIT', template.ID)
                                        event.stopPropagation()}}
                                    style={this.getTemplateStyle(template.ID)}>
                                <TableCell component="th" scope="row">
                                    {template.Name}
                                </TableCell>
                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="add" component="span"
                                        onClick={event=>this.handleMenuClick(event, template.ID)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                        <Menu anchorEl={this.state.menuAnchor} keepMounted
                            open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('FIELD_TEMPLATE_EDITOR_OPEN_EDIT', this.state.menuItemID)}}>
                                <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                                <ListItemText primary={t('EditTemplate')+'...'} />
                            </MenuItem>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('FIELD_TEMPLATE_EDITOR_DELETE', this.state.menuItemID)}}>
                                <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                                <ListItemText primary={t('DeleteTemplate')} />
                            </MenuItem>
                        </Menu>
                    </Table>
                </Paper>
            </>
        )

    }

}

export const TemplatesListEditor = withTranslation()(TemplatesListEditor_);